module.exports = __webpack_public_path__ + "img/googlereviewsp8.bc1dd8b0.png";